<div class="desktop-overlay"
     [ngStyle]="{ top: top + 'px', left: left + 'px', width: width + 'px', height: height + 'px' }"
     (mousedown)="onOverlayMouseDown($event)">

  <!-- Resize handles (8 directions) -->
  <div class="resize-handle resize-n"  (mousedown)="startResize($event, 'n')"></div>
  <div class="resize-handle resize-s"  (mousedown)="startResize($event, 's')"></div>
  <div class="resize-handle resize-e"  (mousedown)="startResize($event, 'e')"></div>
  <div class="resize-handle resize-w"  (mousedown)="startResize($event, 'w')"></div>
  <div class="resize-handle resize-ne" (mousedown)="startResize($event, 'ne')"></div>
  <div class="resize-handle resize-nw" (mousedown)="startResize($event, 'nw')"></div>
  <div class="resize-handle resize-se" (mousedown)="startResize($event, 'se')"></div>
  <div class="resize-handle resize-sw" (mousedown)="startResize($event, 'sw')"></div>

  <!-- Header / drag bar -->
  <div class="desktop-overlay-header" (mousedown)="startDrag($event)">
    <span class="header-title">🖥️ Desktop View — {{ terminalId }}</span>
    <span class="fps-counter" *ngIf="fps > 0">{{ fps }} fps</span>
    <button nbButton status="danger" size="tiny" (click)="endControl()">END DESKTOP CONTROL</button>
  </div>

  <!-- Desktop frame -->
  <div class="desktop-overlay-body">
    <img #desktopImg
         [src]="currentFrameSrc || ''"
         *ngIf="currentFrameSrc"
         class="desktop-frame-img"
         tabindex="0"
         alt="Desktop frame"
         draggable="false"
         (mousedown)="onImgMouseDown($event)"
         (mouseup)="onImgMouseUp($event)"
         (mousemove)="onImgMouseMove($event)"
         (dblclick)="onImgDblClick($event)"
         (wheel)="onImgWheel($event)"
         (keydown)="onImgKeyDown($event)"
         (keyup)="onImgKeyUp($event)"
    />
    <div class="connecting-label" *ngIf="!currentFrameSrc">
      <span>Connecting…</span>
    </div>
  </div>
</div>
